<template>
  <vue-modal :active="active" container-class="bg-smoke" @closed="$emit('closed')">
    <div class="box p-0">
      <user-form :model="user"
                 :resource="resource"
                 :action="action"
                 :canUpdate="canUpdate"
                 :canDelete="canDelete"
                 @created="handleCreated"
                 @updated="handleUpdated"
                 @deleted="handleDeleted"/>
    </div>
  </vue-modal>
</template>

<script>
import modal from '../../mixins/modal';
import resource from '../../mixins/resource';
import UserForm from './UserForm.vue';

export default {
  mixins: [modal, resource],

  components: { UserForm },

  computed: {
    user() {
      return this.data;
    },
    resource() {
      return 'users';
    },
  },

  methods: {
    handleCreated(user) {
      Event.fire('userCreated', user);
    },
    handleUpdated(user) {
      Event.fire('userUpdated', user);
    },
    handleDeleted(user) {
      Event.fire('userDeleted', user);
    },
  },
};
</script>